/**
 * @flow
 */

export default {
  DOWNLOAD_IS_SLOW: 'This is taking a while, do you want to cancel the download and try again?',
  DOWNLOADING: 'Downloading project files...',
  EXTRACTING: 'Extracting project files...',
  CUSTOMIZING: 'Customizing project...',
};
